<template>
    <div class="popup__content popup__content--center">
        <div class="video main-page__video--rel about__video--w100" :class="type">
            <img v-if="!flag" @click="play" class="video__img about__video-img" :src="image" alt=""/>
            <button v-if="!flag" type="button" class="btn video__button video__button--small" @click="play">
                <span class="video__icon"></span>
            </button>

            <iframe v-if="flag && frameType === 'iframe'" class="video__item" :src="embed" frameborder="0" allow="autoplay" allowfullscreen></iframe>
            <video v-else-if="flag && frameType === 'video'" class="video__item" autoplay="autoplay" controls playsinline>
                <source :src="embed" type="video/mp4">
            </video>
        </div>
    </div>
</template>

<script>
export default {
    name: "MainPageVideoFrame",
    data() {
        return {
            image: "/assets/front/img/main-video-cover.png",
            embed: "https://src.memorycode.ru/media/v1_hor.mp4",
            type: "about__video",
            flag: false,
            frameType: 'video',
        }
    },
    methods: {
        play() {
            this.flag = true;
        },
    },
}
</script>
